import { itemNameMap } from './itemNameMap'
import { FormikErrors } from 'formik'
import { ChatInputInitialValues } from '../../formik/initialValues'

export const createErrorMessage = (formikErrors: FormikErrors<ChatInputInitialValues>) =>
  Object.entries(formikErrors).map(([itemName, errorMsg]) => {
    return {
      item: itemName,
      message: `${itemNameMap[itemName]}${errorMsg}`,
    }
  })

export default createErrorMessage